var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mgl-marker',{attrs:{"coordinates":_vm.mapboxLatLong}},[_c('img',{attrs:{"slot":"marker","src":_vm.isHighlighted
        ? require('../../../../images/institution-marker-highlight.png')
        : require('../../../../images/institution-marker.png'),"width":"32","height":"50"},slot:"marker"}),_vm._v(" "),_c('mgl-popup',{attrs:{"offset":[0, -40]}},[_c('div',[_vm._v(_vm._s(_vm._f("institutionDisplayName")(_vm.institution)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }